import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BssoPermissions from 'components/LM/Bsso/Permissions';
import VoiceMerge from 'components/LM/Voice/Merge/VoiceMerge';
import VoiceMergeForm from 'components/LM/Voice/Merge/VoiceMergeForm';

function VoiceMergeView() {
    const [showVoiceMerge, setShowVoiceMerge] = useState(false);
    const [voiceIds, setVoiceIds] = useState([]);
    const location = useLocation();

    useEffect(() => {
		const params = new URLSearchParams(location.search);
        const ids = params.get('ids');

        if (ids) {
			setVoiceIds(ids.split(','));
        }
    }, [location]);

    return (
        <BssoPermissions permissions={["voices"]} behaviour="error">
            <div>
                <VoiceMergeForm onStartMerge={setShowVoiceMerge} setVoiceIds={setVoiceIds} voiceIds={voiceIds} />
                {showVoiceMerge && <VoiceMerge voiceIds={voiceIds} />}
            </div>
        </BssoPermissions>
    );
}

export default VoiceMergeView;
